import { countries, name } from 'country-emoji';
import { useEffect, useState } from 'react';

interface Country {
  countryName: string;
  shortCode: string;
}

interface IReturnType {
  countriesList: Country[]
}

const useCountries = () : IReturnType => {
  const [countriesList, setCountriesList] = useState<Country[]>([]);

  useEffect(() => {
    countries.CI = ['Channel Islands', ''];
    countries.IM = ['Isle of Man', ''];

    const allCountries: Country[] = [];
    Object.keys(countries).map((e) => allCountries.push({ countryName: name(e)!, shortCode: e }));

    setCountriesList(
      allCountries.sort((a, b) => (a.countryName > b.countryName ? 1 : -1)),
    );
  }, []);

  return { countriesList };
};

export default useCountries;
